// extracted by mini-css-extract-plugin
export default {"root":"ReplyTo-root-d5cb678f2840c65ceabc8bb7866321de","text":"ReplyTo-text-ab842808449a5fe23a8f208651cdbb89","username":"ReplyTo-username-1362b415c0276a04d2135bbbaed66a7f"};